import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "chax-ccn" }

import { onMounted } from 'vue';
  import CookieNotice from './components/CookieNotice.vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

  onMounted(() => {
    if(typeof window.CustomEvent === `function`) return;

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    function CustomEvent(event: string, params: { bubbles: boolean; cancelable: boolean; detail: unknown }) {
      // eslint-disable-next-line no-param-reassign
      params = params || { bubbles: false, cancelable: false, detail: null };
      // eslint-disable-next-line no-var,vars-on-top
      var evt = document.createEvent(`CustomEvent`);
      evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
      return evt;
    }

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.CustomEvent = CustomEvent;
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(CookieNotice)
  ]))
}
}

})